export default __webpack_public_path__ + "static/google-26f8bd27d75d6801a0b69607e52d3da0.png";